import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_CAREGIVER_STATUS } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { UpdateCaregiverStatusPayload, UpdateCaregiverStatusResult } from '../types/updateCaregiverStatus.types';

export const updateCaregiverStatus = (builder: BuilderType) =>
  builder.mutation<UpdateCaregiverStatusResult, UpdateCaregiverStatusPayload>({
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_CAREGIVER_STATUS,
    }),
    transformResponse: (response: GenericApiResponse<UpdateCaregiverStatusResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
